import React from "react";
import { FormattedMessage } from "react-intl";
import PropTypes from "prop-types";
import classnames from "classnames";

import { ProfileCardPauseInternet } from "../profileCardPauseInternet";
import { usePauseInternet } from "../../../pauseInternet/PauseInternetProvider";
import { ButtonLink } from "../../../buttonLink/ButtonLink";
import { useIntlTranslate } from "../../../../hooks";

import "./ProfileCardDesktop.scss";

export function ProfileCardDesktop({
  profileId,
  profileName,
  ageGroup,
  protectionLevel,
  devicesCount,
  className,
  isDefault,
}) {
  const { isInternetPaused } = usePauseInternet(usePauseInternet);
  const translate = useIntlTranslate();

  const themeKey = isDefault ? "default" : ageGroup;
  const cardTheme = classnames(
    "desktop-card",
    `${themeKey}__theme`,
    className,
    {
      "desktop-card__internet-paused": isInternetPaused,
    }
  );
  const buttonTheme = classnames("desktop-card__button", `button--${themeKey}`);

  return (
    <li className={cardTheme} aria-label={`${profileName}, ${themeKey}`}>
      <div className="desktop-card__header" aria-hidden={true}>
        <div
          className="desktop-card__title"
          aria-label={`${profileName} profile`}
        >
          {profileName}
        </div>
        {ageGroup && (
          <p className="desktop-card__age-group">
            <FormattedMessage id={ageGroup} />
          </p>
        )}
        <div className="desktop-card__image-container">
          <span className="desktop-card__image" />
        </div>
      </div>
      <div className="desktop-card__content">
        <p className="desktop-card__protection-level">
          <FormattedMessage
            id="protection_level_message"
            values={{
              message: (
                <span className="strong">
                  <FormattedMessage id={protectionLevel} />
                </span>
              ),
            }}
          />
        </p>
        <p>
          <FormattedMessage
            id="devices_count"
            values={{
              message: <span className="strong">{devicesCount}</span>,
            }}
          />
        </p>
        <ButtonLink
          to={`/profile/${profileId}`}
          size="large"
          className={buttonTheme}
          aria-label={translate("aria_label_link", {
            linkName: translate("see_details"),
            pageName: translate("profile_details"),
          })}
        >
          <FormattedMessage id="see_details" />
        </ButtonLink>
        <div className="desktop-card__button">
          <ProfileCardPauseInternet
            profileName={profileName}
            hiddenLabel={
              <FormattedMessage
                id="profile_name_internet_pause_settings"
                values={{ profileName }}
              />
            }
          />
        </div>
      </div>
    </li>
  );
}

ProfileCardDesktop.defaultProps = {
  isInternetPaused: false,
};

ProfileCardDesktop.propTypes = {
  profileId: PropTypes.string.isRequired,
  profileName: PropTypes.string.isRequired,
  protectionLevel: PropTypes.string.isRequired,
  devicesCount: PropTypes.number.isRequired,
  ageGroup: PropTypes.oneOf(["default", "adults", "teens", "kids"]),
  className: PropTypes.string,
  isDefault: PropTypes.bool,
};
